import React from 'react';
import { Tooltip, Zoom, Button, Typography, TableCell, Box } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DownloadIcon from '@mui/icons-material/Download';

export const CourseWithCertifiedList = ({ coursesCertified, onPrint }) => {
  const columns = [
    {
      name: 'Turma.ano',
      label: 'Conclusão',
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: 'center',
        }),
        setCellProps: () => ({
          align: 'center',
        }),
        customBodyRender: (value) => (
          <Typography variant={'body1'}>{value ?? '-'}</Typography>
        ),
      },
    },
    {
      name: 'Turma.Curso.nome',
      label: 'Nome',
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          width: '40%',
        }),
        setCellProps: () => ({
          width: '40%',
        }),
      },
    },
    {
      name: 'Turma.local',
      label: 'Local',
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: 'center',
        }),
        setCellProps: () => ({
          align: 'center',
        }),
        customBodyRender: (value) => (
          <Typography variant={'body1'}>{value ?? '-'}</Typography>
        ),
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: 'center',
        }),
        setCellProps: () => ({
          align: 'center',
        }),
        customBodyRender: (value) => (
          <Typography variant={'body1'}>{value ?? '-'}</Typography>
        ),
      },
    },
    {
      name: 'Turma.Curso.nome',
      label: 'Gerar Certificado',
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: 'center',
        }),
        setCellProps: () => ({
          align: 'center',
        }),
        customHeadRender: (
          columnMeta,
          handleToggleColumn,
          sortOrder,
          sortColumn
        ) => (
          <TableCell align='center'>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Gerar Certificado
              <Box
                component='span'
                sx={{
                  fontSize: '0.7rem',
                  color: 'error.main',
                  fontWeight: 'bold',
                  lineHeight: 1,
                }}
              >
                (Somente após 2024)
              </Box>
            </Box>
          </TableCell>
        ),
        customBodyRender: (value, tableMeta) => {
          const courseData = coursesCertified[tableMeta.rowIndex];

          if (courseData.ano_de_conclusao < 2024) return null;

          return (
            <Button
              disableElevation
              variant={'contained'}
              size={'small'}
              color={'info'}
              onClick={() => onPrint(courseData)}
            >
              <Tooltip
                title='Gerar Certificado Individual'
                TransitionComponent={Zoom}
                arrow
              >
                <DownloadIcon />
              </Tooltip>
            </Button>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'checkbox',
    selectableRows: 'none',
    search: false,
    download: false,
    print: false,
    sortFilterList: false,
    viewColumns: false,
    filter: false,
    expandableRows: false,
    expandableRowsHeader: false,
    enableNestedDataAccess: '.',
  };

  const components = {
    ExpandButton: function () {
      return <div style={{ width: '24px' }} />;
    },
  };

  return (
    <>
      {coursesCertified && coursesCertified.length > 0 ? (
        <MUIDataTable
          data={coursesCertified}
          columns={columns}
          options={options}
          components={components}
        />
      ) : (
        <Typography>Nenhum histórico encontrado</Typography>
      )}
    </>
  );
};
